import React from "react";
import AuthContextWrapper from "./auth/AuthContextWrapper";
import NavigationContextWrapper from "./navigation/NavigationContextWrapper";
import BreadcrumbContextWrapper from "./breadcrumb/BreadcrumbContextWrapper";
import ErrorContextWrapper from "./error/ErrorContextWrapper";
import HistoryContextWrapper from "./history/HistoryContextWrapper";


export default function ({children}) {

    return <ErrorContextWrapper>
        <HistoryContextWrapper>
            <AuthContextWrapper>
                <NavigationContextWrapper>
                    <BreadcrumbContextWrapper>
                        {children}
                    </BreadcrumbContextWrapper>
                </NavigationContextWrapper>
            </AuthContextWrapper>
        </HistoryContextWrapper>
    </ErrorContextWrapper>;
}
